import {Fragment, useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {notification} from "antd";
import ActionBar from "~/layout/ActionBar";
import {
	Loading, Icon, Button, Modal
} from "~/components";
import {
	apiError,
	handleRequest
} from "~/utils";
import {
	recurringVoucherActions,
	recurringVoucherErrorSelector,
	recurringVoucherFilterSelector,
	recurringVoucherItemsSelector,
	recurringVoucherLoadingSelector,
	recurringVoucherPaginationSelector
} from "../recurringVoucherSlice";
import {
	RecurringVoucherTable,
	RecurringVoucherFormAddEdit
} from "../components";
import {
	recurringVoucherApi,
	receiptApi,
	expenseApi
} from "~/api";

function RecurringVoucher() {

	const dispatch  = useDispatch();

	const items     = useSelector(recurringVoucherItemsSelector);

	const loading   = useSelector(recurringVoucherLoadingSelector);

	const error     = useSelector(recurringVoucherErrorSelector);

	const pagination = useSelector(recurringVoucherPaginationSelector);

	const filter    = useSelector(recurringVoucherFilterSelector);

	const [itemEdit, setItemEdit] = useState({});

	const [receiptCategories, setReceiptCategories] = useState({});

	const [expenseCategories, setExpenseCategories] = useState({});

	//Model
	const [openModal, setOpenModal] = useState({
		addEdit     : false,
		delete      : false,
	});

	const handleModalOpen = (modal) => {
		openModal[modal] = true;
		setOpenModal({...openModal})
	}

	const handleModalClose = (modal) => {
		openModal[modal] = false;
		setOpenModal({...openModal});
	}

	const handleLoadCategories = async () => {
		let [, receiptRes] = await handleRequest(receiptApi.groupGets());
		if(receiptRes?.data) setReceiptCategories(receiptRes.data);

		let [, expenseRes] = await handleRequest(expenseApi.groupGets());
		if(expenseRes?.data) setExpenseCategories(expenseRes.data);
	}

	//Load data
	useEffect(() => {
		handleLoadCategories();
	}, []);

	useEffect(() => {
		dispatch(recurringVoucherActions.fetchData({...filter}));
	}, [filter]);

	//Show Error
	if (error) {
		notification.error({message: 'Lỗi', description: error});
	}

	//Submit
	const handleSaveItem = async (data, isEdit) => {
		let messageAction = 'Thêm mới';
		if(isEdit)
		{
			if (!itemEdit?.id)
			{
				notification.error({message: 'Lỗi', description: 'Không có thông tin phiếu định kỳ để cập nhật'});
				return;
			}
			data.id = itemEdit.id;
			messageAction = 'Cập nhật';
		}
		let [error, response] = (isEdit) ? await handleRequest(recurringVoucherApi.update(data)) : await handleRequest(recurringVoucherApi.add(data));
		let message = apiError(`${messageAction} phiếu định kỳ thất bại`, error, response);
		if(!message)
		{
			notification.success({message: 'Thành công', description: `${messageAction} phiếu định kỳ thành công`});
			if(!isEdit)
			{
				dispatch(recurringVoucherActions.add(response.data));
			}
			else {
				setItemEdit(response.data);
				dispatch(recurringVoucherActions.update(response.data));
			}
			handleModalClose('addEdit')
		}
	}

	//Delete
	const handleDelete = async () =>
	{
		if (!itemEdit?.id)
		{
			notification.error({message: 'Lỗi', description: 'Không có thông tin phiếu định kỳ để xóa'});
			return;
		}
		let [error, response] = await handleRequest(recurringVoucherApi.delete(itemEdit.id));

		let message = apiError(`xóa phiếu định kỳ thất bại`, error, response);

		if(!message)
		{
			notification.success({message: 'Thành công', description: `xóa phiếu định kỳ thành công`});
			dispatch(recurringVoucherActions.delete(itemEdit.id));
			handleModalClose('delete')
		}
	}

	//Pagination
	const handlePaginationChange = (page) => {
		dispatch(recurringVoucherActions.setFilter({...filter, page }));
	}

	return (
			<Fragment>
				<ActionBar title={'Phiếu định kỳ'}>
					<Button outline leftIcon={Icon.plusCircle} onClick={() => {setItemEdit({});handleModalOpen('addEdit')}}>Thêm mới</Button>
					<Button outline small onClick={() => dispatch(recurringVoucherActions.fetchData({...filter}))} style={{fontSize:'20px'}}>{Icon.reload}</Button>
				</ActionBar>
				<div className="container">
					<div className="content">
						{loading && <Loading/>}
						{items && <RecurringVoucherTable
							items={items}
							pagination={pagination}
							onPaginationChange={handlePaginationChange}
							setItemEdit={setItemEdit}
							openModal={handleModalOpen}
						/>}
					</div>
					{
						<Modal title="Phiếu định kỳ" visible={openModal.addEdit} onCancel={() => {handleModalClose('addEdit')}}>
							<RecurringVoucherFormAddEdit
								item={itemEdit}
								receiptCategories={receiptCategories}
								expenseCategories={expenseCategories}
								onHandleSubmit={handleSaveItem}
							/>
						</Modal>
					}
					{
						(itemEdit?.id) && <Modal title="Xóa phiếu định kỳ" visible={openModal.delete} onCancel={() => {handleModalClose('delete')}}>
							<p>Bạn muốn xóa phiếu định kỳ <b>{itemEdit?.name}</b>?</p>
							<br />
							<div className="d-flex justify-content-end gap pd-1 modal-bottom">
								<Button white leftIcon={Icon.close} onClick={() => {handleModalClose('delete')}}> Đóng </Button>
								<Button primary leftIcon={Icon.delete} onClick={handleDelete}> Xóa </Button>
							</div>
						</Modal>
					}
				</div>
			</Fragment>
	)
}
export default RecurringVoucher;
